import useFetch from 'core/redux/hooks/useFetch';
import fetchCategories from 'app/games/taboo/actions/fetchCategories';

export default function useFetchCategories() {
  return useFetch(fetchCategories);
}
